<div class="tenant-selector-header" *ngIf="hasMultipleTenants()" ngbDropdown placement="bottom-end">
  <button
    class="btn btn-action-outline btn-tenant-switch btn-sm d-flex align-items-center gap-2"
    type="button"
    ngbDropdownToggle
    [disabled]="switching"
    [attr.aria-label]="currentTenant?.displayName || ('TenantSwitch.SelectTenant' | translate)"
    [attr.title]="currentTenant?.displayName || ('TenantSwitch.SelectTenant' | translate)">
    <i class="bi bi-buildings tenant-switch-icon" aria-hidden="true"></i>
    <span class="tenant-name text-truncate">
      {{ currentTenant?.displayName || ('TenantSwitch.SelectTenant' | translate) }}
    </span>
    <span class="badge badge-soft-primary rounded-pill tenant-count" *ngIf="availableTenants?.length">
      {{ availableTenants.length }}
    </span>
    <span class="spinner-border spinner-border-sm" *ngIf="switching" role="status">
      <span class="visually-hidden">{{ 'TenantSwitch.Switching' | translate }}</span>
    </span>
  </button>

  <div ngbDropdownMenu class="dropdown-menu-end tenant-switch-menu shadow">
    <h6 class="dropdown-header text-muted">
      <i class="bi bi-buildings me-2" aria-hidden="true"></i>
      {{ 'TenantSwitch.AvailableTenants' | translate }}
    </h6>
    <div class="dropdown-divider"></div>
    <button
      type="button"
      ngbDropdownItem
      *ngFor="let tenant of availableTenants"
      class="d-flex align-items-center tenant-switch-item"
      [class.active]="tenant.isCurrent"
      [disabled]="tenant.isCurrent || switching"
      (click)="switchTenant(tenant)">
      <i class="bi bi-building me-2" aria-hidden="true"></i>
      <span class="flex-grow-1 text-truncate">{{ tenant.displayName }}</span>
      <i class="bi bi-check-circle-fill text-success ms-2" *ngIf="tenant.isCurrent" aria-hidden="true"></i>
      <span class="visually-hidden" *ngIf="tenant.isCurrent">{{ 'TenantSwitch.Current' | translate }}</span>
    </button>
  </div>
</div>
